import { NumberInput } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, input, numberAttribute } from '@angular/core';

export type SkeletonType = 'block' | 'pill' | 'circle';

@Component({
  selector: 'joii-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  styleUrl: './skeleton.component.css',
  host: {
    role: 'presentation',
    'aria-hidden': 'true',
    '[attr.data-type]': 'type()',
    '[style.--joii-skeleton-width]': 'width()',
    '[style.--joii-skeleton-height]': 'height()',
    '[style.animation-delay.ms]': 'offset()',
  },
})
export class SkeletonComponent {
  /** CSS length, e.g. `100%`, `200px`, `1rem` */
  readonly width = input<string>('100%');
  readonly height = input<string>('16px');
  /** Shape variant; default is rectangular block */
  readonly type = input<SkeletonType>('block');
  /** Animation delay in milliseconds for staggering multiple skeletons */
  readonly offset = input<number, NumberInput>(0, { transform: numberAttribute });
}
